export const dateToServerTimeString = (dateObj) => {
  return dateObj.toISOString();
};
